import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class GanttChartPropsBuilder extends PropsBuilder<'ganttChart'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { general: { visualEffect } } });
    return this;
  };

  constructor(props: PartialPropsOf<'ganttChart'> | undefined) {
    super(props, { hasData: true, hasLabel: true });
  }
}
